// =============================================================================
// src/views/workspace/workspace-map-snapshot.ts — Cache da última seleção de mapa.
//
// Captura NÃO-INVASIVA do estado do mapa: o MapController não expõe a zona
//   selecionada, então escutamos region:select no AppBus e guardamos a última
//   {zona,latlng}. O modal "Nova análise" usa esse cache para pré-preencher a
//   região (A2: seção vem do SectionManager; zona vem daqui).
//
// SRP: só o cache do snapshot. Sem DOM, sem store, sem markup.
// =============================================================================

import type { AppBus } from '../../app/types';
import type { WorkspaceMapSnapshot } from './workspace-types';

/** Guarda a última seleção de região emitida no AppBus. */
export class WorkspaceMapSnapshotCache {
  private snapshot: WorkspaceMapSnapshot | null = null;

  /** Liga o cache ao barramento (idempotente o bastante: bindOnce na raiz evita duplicar). */
  attach(bus: AppBus): void {
    bus.on('region:select', (payload) => {
      this.snapshot = { zona: payload.zona, latlng: payload.latlng };
    });
  }

  /** Última seleção capturada, ou null se nada foi selecionado ainda. */
  last(): WorkspaceMapSnapshot | null {
    return this.snapshot;
  }
}
